// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"68":"business","443":"about","631":"contact","697":"news"}[chunkId] || chunkId) + "." + {"68":"33e99033","443":"ef41e48e","564":"db426e2c","631":"73e3027a","697":"7d4f0458"}[chunkId] + ".css";
};